import { Modal } from 'antd';
import LoginForm from '../forms/login';
import { useModal } from './useModal';

const LoginModal = () => {
  const { closeModal, open } = useModal('login');

  return (
    <Modal open={open} onCancel={closeModal} footer={null} centered>
      <LoginForm />
    </Modal>
  );
};

export default LoginModal;
